import React from 'react';
import { X } from 'lucide-react';

interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function TermsModal({ isOpen, onClose }: TermsModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white p-6 rounded-lg w-full max-w-3xl mx-auto shadow-xl max-h-[80vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4 sticky top-0 bg-white py-2 border-b">
          <h2 className="text-2xl font-bold text-orange-500">Terms of Service</h2>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-orange-500 transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="space-y-6 text-gray-700">
          <section>
            <h2 className="text-xl font-semibold mb-4">1. Acceptance of Terms</h2>
            <p>
              By accessing and using Show Your Bits, you agree to be bound by these Terms of Service. 
              If you do not agree to these terms, please do not use our service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">2. User Conduct</h2>
            <p>You agree to:</p>
            <ul className="list-disc pl-5 space-y-2 mt-2">
              <li>Provide accurate and complete information when creating your account</li>
              <li>Maintain the security of your account credentials</li>
              <li>Take responsibility for all activities that occur under your account</li>
              <li>Not use the service for any illegal or unauthorized purpose</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">3. Content Guidelines</h2>
            <p>Users must not post content that:</p>
            <ul className="list-disc pl-5 space-y-2 mt-2">
              <li>Is illegal, harmful, or offensive</li>
              <li>Infringes on intellectual property rights</li>
              <li>Contains malware or malicious code</li>
              <li>Violates the privacy of others</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">4. Account Termination</h2>
            <p>
              We reserve the right to suspend or terminate accounts that violate these terms 
              or engage in inappropriate behavior, without warning. Users may also delete their own accounts 
              at any time.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">5. Service Modifications</h2>
            <p>
              We may modify or discontinue any part of our service at any time. We will make 
              reasonable efforts to notify users of significant changes.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">6. Limitation of Liability</h2>
            <p>
              Show Your Bits is provided "as is" without warranties of any kind. We are not 
              liable for any damages arising from your use of our service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">7. Contact</h2>
            <p>
              If you have questions about these Terms of Service, please contact us through 
              the feedback form available in the application.
            </p>
          </section>

          <section className="text-sm text-gray-400">
            <p>Last updated: January 18, 2025</p>
          </section>
        </div>
      </div>
    </div>
  );
}
